<div class="filter">
  <input
    type="text"
    #filter
    (ngModelChange)="change($event)"
    [(ngModel)]="query"
    (focus)="focus()"
    (blur)="blur()"
    placeholder="Filtrujte dle názvu..."
    class="filter__input"
    [ngClass]="{ 'filter__input--opened': opened }"
    [ngStyle]="getStyle()"
  />
  <span
    class="filter__trigger"
    (click)="triggerClick()"
    [ngStyle]="getStyle()"
    [ngClass]="{
      'filter__trigger--opened': opened,
      'filter__trigger--focused': focused
    }"
    ><i [ngClass]="{ 'ico-magnifier': !opened, 'ico-remove': opened }"></i
  ></span>
</div>
